import { render, staticRenderFns } from "./CmgRemoteContent.vue?vue&type=template&id=7bdbe485&scoped=true&lang=pug&"
import script from "./cmg-remote-content.ts?vue&type=script&lang=ts&"
export * from "./cmg-remote-content.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRemoteContent.vue?vue&type=style&index=0&id=7bdbe485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdbe485",
  null
  
)

export default component.exports